const getDefaultState = () => {
    return {
        custom: [], 
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {     
        resetState: (state) => Object.assign(state, getDefaultState()),   
        addBlankCustomTag: (state) => state.custom.push({
            label: '',
            value: '',
        }),
        setCustomTagLabel: (state, { value, index }) => state.custom[index].label = value,
        setCustomTagValue: (state, { value, index }) => state.custom[index].value = value,
        removeCustomTag: (state, index) => state.custom.splice(index, 1),  
    },
}